import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { mergeMap, startWith, withLatestFrom } from 'rxjs/operators';
import { ConfigService } from '@mona/config';
import { DataAccessExternalResourcesFacade } from '@mona/pdms/data-access-external-resources';
import { takeUntilDestroy, TakeUntilDestroy } from '@mona/shared/utils';
import { UiModule } from '@mona/ui';
import { ExternalLink } from '../../../../../mona/api/src/lib/model';

@Component({
    template: `
        <ui-drawer-portals>
            <ng-template uiToolbarTitle>
                {{ title }}
            </ng-template>
        </ui-drawer-portals>

        <ui-drawer-content>
            <mat-tab-group ui-drawer-content-nav>
                <mat-tab *ngFor="let link of links">
                    <ng-template mat-tab-label>
                        <span *ngIf="link.icon">
                            <img
                                class="link-icon"
                                [width]="24"
                                [height]="24"
                                alt="icon"
                                [src]="configService.get('api.baseUrl') + link.icon"
                            />
                            &nbsp;
                        </span>
                        <span>{{ link?.name }}</span>
                    </ng-template>
                    <div class="iframe-container">
                        <iframe [src]="link.url | safeUrl: 'resource'"></iframe>
                    </div>
                </mat-tab>
            </mat-tab-group>
            >
        </ui-drawer-content>
    `,
    imports: [UiModule],
    standalone: true,
})
@TakeUntilDestroy
export class InternalAppComponent implements OnInit, OnDestroy {
    title: string;
    links: ExternalLink[] = [];

    constructor(
        private ar: ActivatedRoute,
        private externalResourcesFacade: DataAccessExternalResourcesFacade,
        public configService: ConfigService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        combineLatest([
            this.ar.url.pipe(startWith(this.ar.snapshot.url)),
            this.externalResourcesFacade.internalApplications$,
        ])
            .pipe(takeUntilDestroy(this))
            .subscribe(([url, internalApplications]) => {
                this.links = [];
                this.title = '';

                const linksGroup = internalApplications.find(app => app.name === url[1].path);

                if (linksGroup) {
                    this.links = linksGroup.resources;
                    this.title = linksGroup.name;
                    this.cdr.detectChanges();
                }
            });
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, jsdoc/require-jsdoc
    ngOnDestroy(): void {
        // empty
    }
}
